import React from "react";
import {Navigate, useLocation} from "react-router-dom";
import {useUser} from "./UserProvider";
import LoadingWidget from "../components/LoadingWidget"; // Import the context

const PrivateRoute = ({children}) => {
    const {user, loading} = useUser(); // Access user and loading from context
    const location = useLocation(); // Get the current location to redirect the user back after login

    // If user data is still being loaded, we can show a loading indicator or just wait
    if (loading) {
        return (<div className={"loading-private"} style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100vh"}}>
            <LoadingWidget/></div>); // Or you can display a loading spinner
    }

    // If user is not logged in, redirect to the login page and preserve the current location
    if (!user) {
        return <Navigate to={`/sign-in?redirect=${location.pathname}`} state={{from: location}} replace/>;
    }

    // If user is logged in, render the requested route
    return children;
};

export default PrivateRoute;
